module.exports = __webpack_public_path__ + "static/media/4.c22f28d2.png";